export const TYPE_MOVITEL_REVENUE = "TYPE_MOVITEL_REVENUE";
export const TYPE_MOVITEL_ERROR_CODE = "TYPE_MOVITEL_ERROR_CODE";
export const TYPE_MOVITEL_VM = "TYPE_MOVITEL_VM";
export const TYPE_MOVITEL_MAGICWHEEL = "TYPE_MOVITEL_MAGICWHEEL";
